<template>
  <Alert v-if="status.isLoaded" variant="warning" :dismissible="false">
    <p>{{ $t("global.dns-zone-authoritative-message") }}</p>
    <div v-for="(domain, index) in authoritative" :key="index" class="text-center">
      {{ domain }}
    </div>
  </Alert>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Alert from "@/components/display/Alert";
import store from "@/store";

export default {
  name: "DnsZoneAuthoritative",
  components: {
    Alert,
  },
  setup() {
    const authoritative = computed(() => store.getters["dnsZones/getAuthoritative"]);
    const status = computed(() => store.getters["dnsZones/getAuthoritativeStatus"]);

    onMounted(() => {
      store.dispatch("dnsZones/getAuthoritative");
    });

    return {
      authoritative,
      status,
    };
  },
};
</script>
